import { wrappedActionTypes } from './constants';
import { ChapterItem } from '../types';

export function getYearSummaryRequest() {
	return {
		type: wrappedActionTypes.GET_YEAR_SUMMARY_REQUEST,
	};
}

export function getYearSummarySuccess(availableChapters: ChapterItem[]) {
	return {
		type: wrappedActionTypes.GET_YEAR_SUMMARY_SUCCESS,
		payload: {
			availableChapters,
		},
	};
}

export function getYearSummaryError(error: any) {
	return {
		type: wrappedActionTypes.GET_YEAR_SUMMARY_ERROR,
		payload: {
			error,
		},
	};
}
